<template>
  <div style="height: calc(100vh - 60px); background: #F2F2F6;overflow:auto">
         <el-breadcrumb  separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>硬件管理</el-breadcrumb-item>
        </el-breadcrumb>
   <el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="6">
       <el-form-item label="名称">
    <el-input v-model="where.name"></el-input>
  </el-form-item>
    </el-col>
       <el-col :span="6">
       <el-form-item label="Format">
      <el-input v-model="where.format"></el-input>
  </el-form-item>
     </el-col>
       <el-col :span="6">
         <el-form-item label="">
         </el-form-item>
       </el-col>
       <el-col :span="6" style="text-align:right">
        <el-button size="small" type="primary" @click="searchVersion()">查询</el-button>
          <el-divider  direction="vertical"></el-divider>
          <el-button title="新增硬件" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="createVersion()"></el-button>

      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            :index="indexMethod"
            width="100"
          ></el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="format" label="Format"> </el-table-column>
          <el-table-column prop="fotatype" label="Fota_type"> </el-table-column>
           <el-table-column prop="type" label="硬件类型"> </el-table-column>
            <el-table-column prop="version" label="当前版本"> </el-table-column>
          <el-table-column  column-key="opt"
            label="操作"
             width="150">
            <template slot-scope="scope">
               <el-button
                size="mini"
                type="text"
                title=""
                @click="$router.push({name:'EditVersion',params:{innerid:scope.row.innerid}})"
                >修改</el-button
              >
                <el-divider   direction="vertical"></el-divider>
              <el-button
                size="mini"
                type="text"
                title=""
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'UserList',
  data () {
    return {
      title: 'B端平台权限设置',
      tabledata: [],
      pageset: {
        size: 15,
        index: 1
      },
      totalsize: 0,
      where: {
        name: '',
        username: ''
      }
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      self.searchVersion()
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    createVersion () {
      this.$router.push({name: 'EditVersion', params: {innerid: ''}})
    },
    searchVersion () {
      var self = this
      Vue.axios
        .post('/version/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/version/list/count', {
          where: this.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchVersion()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchVersion()
    },
    handleDelete (row) {
      this.$confirm(
        '确定删除硬件版本' + row.name + '(' + (row.username || '-') + ')？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/version/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                self.searchVersion()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Version/Index.vue